import { useEffect } from "react";

import Main from "../components/Stock/Main";
import Cards from "../components/Stock/Cards";
import WhatIsTradeStock from "../components/Stock/WhatIsTradeStock";
import HowTradeStock from "../components/Stock/HowTradeStock";
import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import NeedHelp from "../components/Home/NeedHelp";

function Stock() {
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Main />   
            <Cards/>
            <WhatIsTradeStock/>
            <HowTradeStock/>
            <WhyArvest />
            <ArvestOffers />
            <NeedHelp />
        </div>
    );
}

export default Stock;
